import '../sass/Timeline.scss'

const events = [
    { text: 'Bac 2021 mention bien', done: true },
    { text: 'Stage Symfony chez NOOUS', done: true },
    { text: 'Bachelor informatique chez\nToulouse YNOV Campus', done: true },
    { text: 'Alternance chez Voltaire Digital', done: false },
    { text: 'Master développement full stack chez\nToulouse YNOV Campus', done: false },
]

function Timeline() {
    return <div className="timeline" id='timeline'>
        {events.map((event, i) => (
            <div className="timeline-item" key={i}>
                <div className="timeline-content">
                    <p>{event.text}</p>
                </div>
                <div className="timepoint">
                    <div className={event.done ? 'insidepoint' : 'insidewhitepoint'}></div>
                </div>
            </div>
        ))}
    </div>
}
export default Timeline
